/* Nostalgible storefront — homepage, /pages/shop and /pages/item all render from the eBay feed (Cloudflare Worker). */
const WORKER = 'https://nostalgible-ebay-feed.jasonwoody88.workers.dev';
const $ = (id) => document.getElementById(id);
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const fmt = (n) => '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const gradeOf = (t) => (String(t).match(/\b(CGC|CBCS|PSA|PMG|BGS|SGC)\s*\d+(\.\d)?/i) || [''])[0].toUpperCase();
const img = (it, alt = '') => it.image ? `<img src="${esc(it.image)}" alt="${esc(alt)}" loading="lazy">` : '<span class="mono" style="font-size:12px;color:#6b6760">[Photo]</span>';
// Item links go to the indexable pages served through the app proxy (same slug rule as the worker).
const slugify = (t) => String(t || '').toLowerCase().replace(/&/g, ' and ').replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 80).replace(/-+$/, '');
const itemUrl = (id, title) => `/apps/items/${encodeURIComponent(id)}-${slugify(title)}`;
const shopUrl = (cat) => '/pages/shop' + (cat && cat !== 'All' ? `?cat=${encodeURIComponent(cat)}` : '');
const offerAttr = (it) => esc(JSON.stringify({ t: it.title, id: it.id, p: it.price }));
const params = new URLSearchParams(location.search);

let all = [], cat = 'All', sort = 'high', slides = [], timer = null;

/* ---------- feed (instant from browser cache, then fresh from the worker) ---------- */
const FEED_URL = () => ($('nostalgible-home')?.dataset.listingsUrl || `${WORKER}/listings`);
const CACHE_KEY = 'nostalgible_listings_v1';
const HIDE_CATS = ['Toys']; // eBay categories pulled by the feed but not shown on the site
const readCache = () => { try { return JSON.parse(localStorage.getItem(CACHE_KEY) || 'null'); } catch { return null; } };
const writeCache = (data) => { try { localStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), data })); } catch {} };
async function loadFeed(onData) {
  let sig = '', got = false;
  const apply = (data) => {
    data = data.filter((x) => !HIDE_CATS.includes(x.category));
    const s = data.length + ':' + data.slice(0, 50).map((x) => x.id + x.price).join(',');
    if (s === sig) return; sig = s; got = true; onData(data);
  };
  const c = readCache();
  if (c && Array.isArray(c.data) && c.data.length && Date.now() - c.at < 864e5) apply(c.data);
  try {
    const data = await (await fetch(FEED_URL())).json();
    if (Array.isArray(data) && data.length) { writeCache(data); apply(data); }
  } catch (e) { console.warn('Nostalgible: eBay feed unavailable', e); }
  return got;
}
const feedDown = '<p class="feed-down">Live listings are temporarily unavailable — <a href="https://www.ebay.com/str/sneakerbrokers">browse the full store on eBay</a>.</p>';

/* ---------- cards ---------- */
function cardHTML(it) {
  return `<div class="card"><a class="card-link" href="${itemUrl(it.id, it.title)}"><div class="thumb">${img(it, it.title)}</div>
    <div class="card-title">${esc(it.title)}</div>
    <div class="prices"><span class="p">${fmt(it.price)}</span>${it.was ? `<span class="w">${fmt(it.was)}</span>` : ''}</div></a></div>`;
}

/* ---------- carousel (homepage) ---------- */
function renderCarousel() {
  const keep = $('track').scrollLeft;
  $('track').innerHTML = slides.map((it, i) => {
    const g = gradeOf(it.title);
    const off = it.was ? Math.round((1 - it.price / it.was) * 100) : 0;
    return `<div class="slide"><a class="slide-link" href="${itemUrl(it.id, it.title)}" aria-label="${esc(it.title)} — ${fmt(it.price)} (${i + 1} of ${slides.length})">
      <div class="slide-img">${img(it)}${off ? `<span class="off">${off}% off</span>` : ''}${g ? `<span class="grade">${esc(g)}</span>` : ''}</div>
      <div class="slide-title">${esc(it.title)}</div>
      <div class="slide-price"><span>${fmt(it.price)}</span>${it.was ? `<s>${fmt(it.was)}</s>` : ''}</div></a>
      <div class="acts"><button class="mini" type="button" data-offer="${offerAttr(it)}">Make offer</button><a class="mini ghost" href="${esc(it.url)}">eBay</a></div></div>`;
  }).join('');
  $('track').scrollLeft = keep; $('track').removeAttribute('aria-busy');
}
function step(dir) {
  const t = $('track'), card = t.firstElementChild; if (!card) return;
  const w = card.getBoundingClientRect().width + 16;
  if (dir > 0 && t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) t.scrollTo({ left: 0, behavior: 'smooth' });
  else t.scrollBy({ left: dir * w, behavior: 'smooth' });
}
function progress() {
  const t = $('track'), max = t.scrollWidth - t.clientWidth;
  $('bar').style.width = (max > 0 ? (t.clientWidth + t.scrollLeft) / t.scrollWidth * 100 : 100) + '%';
}
function stopAuto() { clearInterval(timer); timer = null; }
function wireCarousel() {
  const t = $('track');
  $('prev').onclick = () => { stopAuto(); step(-1); };
  $('next').onclick = () => { stopAuto(); step(1); };
  t.addEventListener('scroll', progress, { passive: true });
  ['pointerdown', 'wheel', 'touchstart', 'focusin'].forEach((e) => t.addEventListener(e, stopAuto, { passive: true }));
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => step(1), 4000);
}

/* ---------- grid + categories (homepage and /pages/shop) ---------- */
const PAGE = 48;
let query = '', limit = PAGE;
const words = (s) => String(s).toLowerCase().replace(/[#.,]/g, ' ').split(/\s+/).filter(Boolean);
const onShopPage = () => !!$('nostalgible-shop');
function categories() {
  const counts = {};
  for (const x of all) counts[x.category || 'Other'] = (counts[x.category || 'Other'] || 0) + 1;
  return [['All', all.length], ...Object.entries(counts).sort((a, b) => b[1] - a[1])];
}
function syncUrl() {
  if (!onShopPage()) return;
  const p = new URLSearchParams();
  if (cat !== 'All') p.set('cat', cat);
  if (query) p.set('q', query);
  history.replaceState(null, '', '/pages/shop' + (p.toString() ? '?' + p : ''));
  const label = cat === 'All' ? 'All listings' : cat;
  $('shop-title').textContent = cat === 'All' ? 'shop all listings' : cat.toLowerCase();
  $('crumb-cat').textContent = label;
  document.title = `${label}${query ? ` matching “${query}”` : ''} | Nostalgible`;
}
function setCat(c) { cat = c; limit = PAGE; renderCats(); renderGrid(); syncUrl(); }
function renderCats() {
  const cs = categories();
  $('cats').innerHTML = cs.map(([c, n]) => `<button type="button" aria-pressed="${c === cat}" data-cat="${esc(c)}">${esc(c === 'All' ? 'All categories' : c)} <span>${n.toLocaleString()}</span></button>`).join('');
  $('chips').innerHTML = cs.map(([c]) => `<button type="button" aria-pressed="${c === cat}" data-cat="${esc(c)}">${esc(c)}</button>`).join('');
}
function renderGrid() {
  const q = words(query);
  let list = cat === 'All' ? all.slice() : all.filter((x) => x.category === cat);
  if (q.length) list = list.filter((x) => { const t = ' ' + words(x.title).join(' ') + ' '; return q.every((w) => t.includes(w)); });
  if (sort === 'low') list.sort((a, b) => a.price - b.price);
  if (sort === 'high') list.sort((a, b) => b.price - a.price);
  if (sort === 'new') list.sort((a, b) => (Date.parse(b.listed) || 0) - (Date.parse(a.listed) || 0) || String(b.id).localeCompare(String(a.id)));
  const shown = list.slice(0, limit);
  $('count').textContent = list.length ? `Showing ${shown.length} of ${list.length.toLocaleString()} listing${list.length === 1 ? '' : 's'}${query ? ` for “${query}”` : ''}` : '';
  $('more').hidden = shown.length >= list.length;
  $('more').textContent = `Show more (${(list.length - shown.length).toLocaleString()} left)`;
  $('none').hidden = list.length > 0;
  $('grid').innerHTML = shown.map(cardHTML).join('');
  $('grid').removeAttribute('aria-busy');
}
function setQuery(v, scroll) {
  query = v.trim(); limit = PAGE; $('gq').value = query; if ($('q')) $('q').value = query;
  renderGrid(); syncUrl();
  if (scroll) $('shop').scrollIntoView({ behavior: 'smooth', block: 'start' });
}
function wireGrid() {
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-cat]'); if (b) setCat(b.dataset.cat); });
  $('sort').onchange = (e) => { sort = e.target.value; limit = PAGE; renderGrid(); };
  $('more').onclick = () => { limit += PAGE; renderGrid(); };
  let deb; $('gq').addEventListener('input', (e) => { clearTimeout(deb); deb = setTimeout(() => setQuery(e.target.value, false), 150); });
}

async function initListings() {
  const home = !!$('nostalgible-home');
  let first = true;
  const ok = await loadFeed((data) => {
    all = data;
    if (home && $('track')) { slides = [...all].sort((a, b) => b.price - a.price).slice(0, 16); renderCarousel(); progress(); }
    if ($('stat-live')) $('stat-live').textContent = all.length.toLocaleString();
    if (first) {
      first = false;
      const c = params.get('cat'); if (c && all.some((x) => x.category === c)) cat = c;
      query = params.get('q') || '';
      if ($('gq')) $('gq').value = query;
      const so = params.get('sort'); if (['new', 'high', 'low'].includes(so) && $('sort')) { sort = so; $('sort').value = so; }
      if (home && $('track')) wireCarousel();
      wireGrid(); syncUrl();
      if (query && home) setTimeout(() => $('shop').scrollIntoView({ block: 'start' }), 0);
    }
    renderCats(); renderGrid();
  });
  if (!ok) { if ($('track')) $('track').innerHTML = feedDown; $('grid').innerHTML = feedDown; $('cats').innerHTML = ''; $('count').textContent = ''; $('more').hidden = true; }
}

/* ---------- item page ---------- */
/* rollover zoom: lens on the photo, magnified view over the details column */
function setupZoom() {
  const main = $('main-img'), pane = $('zoom-pane');
  if (!main || !pane) return;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const Z = 2.5;
  const hide = () => { pane.hidden = true; const l = $('zoom-lens'); if (l) l.hidden = true; main.classList.remove('zooming'); };
  main.addEventListener('click', () => { const im = $('main-photo'); if (im) window.open(im.src, '_blank', 'noopener'); });
  if (!fine) return;
  main.addEventListener('mousemove', (e) => {
    const im = $('main-photo'), lens = $('zoom-lens');
    if (!im || !lens || !im.naturalWidth) return;
    const c = main.getBoundingClientRect();
    const r = Math.min(c.width / im.naturalWidth, c.height / im.naturalHeight);
    const w = im.naturalWidth * r, h = im.naturalHeight * r, ox = (c.width - w) / 2, oy = (c.height - h) / 2;
    const x = e.clientX - c.left - ox, y = e.clientY - c.top - oy;
    if (x < 0 || y < 0 || x > w || y > h) return hide();
    pane.hidden = false; lens.hidden = false; main.classList.add('zooming');
    const pw = pane.clientWidth, ph = pane.clientHeight;
    const lw = Math.min(w, pw / Z), lh = Math.min(h, ph / Z);
    const lx = Math.max(0, Math.min(w - lw, x - lw / 2)), ly = Math.max(0, Math.min(h - lh, y - lh / 2));
    Object.assign(lens.style, { width: lw + 'px', height: lh + 'px', left: ox + lx + 'px', top: oy + ly + 'px' });
    pane.style.backgroundImage = `url("${im.src}")`;
    pane.style.backgroundSize = `${w * Z}px ${h * Z}px`;
    pane.style.backgroundPosition = `${-lx * Z}px ${-ly * Z}px`;
  });
  main.addEventListener('mouseleave', hide);
}


/* "Have one to sell?" → the most specific selling page for this item */
const SELL_MAP = [
  [/hulk\D{0,12}#?181\b/i, 'sell-incredible-hulk-181', 'Hulk #181'], [/giant[- ]?size x-?men\D{0,6}#?1\b/i, 'sell-giant-size-x-men-1', 'Giant-Size X-Men #1'],
  [/amazing spider-?man\D{0,6}#?129\b/i, 'sell-amazing-spider-man-129', 'Amazing Spider-Man #129'], [/amazing spider-?man\D{0,6}#?300\b/i, 'sell-amazing-spider-man-300', 'Amazing Spider-Man #300'],
  [/amazing fantasy\D{0,6}#?15\b/i, 'sell-amazing-fantasy-15', 'Amazing Fantasy #15'],
];
const SELL_TITLES = [
  [/amazing spider-?man/i, 'sell-amazing-spider-man-comics', 'Amazing Spider-Man'], [/fantastic four/i, 'sell-fantastic-four-comics', 'Fantastic Four'],
  [/tales of suspense/i, 'sell-tales-of-suspense-comics', 'Tales of Suspense'], [/tales to astonish/i, 'sell-tales-to-astonish-comics', 'Tales to Astonish'],
  [/journey into mystery/i, 'sell-journey-into-mystery-comics', 'Journey into Mystery'], [/x-?men/i, 'sell-x-men-comics', 'X-Men'],
  [/\bhulk\b/i, 'sell-incredible-hulk-comics', 'Hulk'], [/avengers/i, 'sell-avengers-comics', 'Avengers'],
  [/detective comics/i, 'sell-detective-comics', 'Detective Comics'], [/action comics/i, 'sell-action-comics', 'Action Comics'],
  [/adventure comics/i, 'sell-adventure-comics', 'Adventure Comics'], [/\bshowcase\b/i, 'sell-showcase-comics', 'Showcase'],
  [/brave (and|&) the bold/i, 'sell-brave-and-the-bold-comics', 'Brave and the Bold'], [/\bbatman\b/i, 'sell-batman-comics', 'Batman'],
  [/\bsuperman\b/i, 'sell-superman-comics', 'Superman'],
];
function sellPageFor(title, category) {
  const t = String(title || ''), c = String(category || ''), y = Number((t.match(/\b(19[3-9]\d|20[0-2]\d)\b/) || [])[1]) || 0;
  const isCard = /card|sticker/i.test(c) || /\b(card|cards|sticker|rc|rookie|psa|bgs|sgc|topps|fleer|bowman|donruss|upper deck|skybox|panini|metal universe|pmg)\b/i.test(t);
  if (/sneaker|shoe/i.test(c)) return null;
  if (!isCard) {
    for (const [re, h, l] of SELL_MAP) if (re.test(t)) return [h, l];
    for (const [re, h, l] of SELL_TITLES) if (re.test(t)) return [h, l + ' comics'];
    if (y && y <= 1955) return ['sell-golden-age-comics', 'Golden Age comics'];
    if (y && y <= 1969) return ['sell-silver-age-comics', 'Silver Age comics'];
    if (y && y <= 1985) return ['sell-bronze-age-comics', 'Bronze Age comics'];
    if (/\b(cgc|cbcs)\b/i.test(t)) return ['sell-graded-comics', 'graded comics'];
    if (/marvel/i.test(t)) return ['sell-marvel-comics', 'Marvel comics'];
    if (/\bdc\b/i.test(t)) return ['sell-dc-comics', 'DC comics'];
    return /comic/i.test(c) || /comic/i.test(t) ? ['sell-old-comic-books', 'comics'] : null;
  }
  if (/metal universe|marvel metal|\bpmg\b|precious metal/i.test(t)) return ['sell-marvel-metal-universe-cards', 'Metal Universe cards'];
  if (/marvel/i.test(t) && /\b197[56]\b/.test(t)) return ['sell-1975-1976-topps-marvel-stickers', '1975–76 Topps Marvel stickers'];
  if (/marvel/i.test(t) && /\b1966\b/.test(t)) return ['sell-1966-marvel-super-heroes-cards', '1966 Marvel cards'];
  if (/marvel|x-?men|spider-?man/i.test(t)) return ['sell-marvel-cards', 'Marvel cards'];
  if (/batman|superman|\bdc\b|justice league|joker/i.test(t)) return ['sell-dc-comics-cards', 'DC cards'];
  if (/non-sport/i.test(c) || /star wars|garbage pail|wacky|pokemon/i.test(t)) return ['sell-non-sport-cards', 'non-sport cards'];
  if (y && y < 1960) return ['sell-vintage-sports-cards-1940s-1950s', '1940s–50s sports cards'];
  if (y && y < 1980) return ['sell-vintage-sports-cards-1960s-1970s', '1960s–70s sports cards'];
  if (y && y < 2000) return ['sell-vintage-sports-cards-1980s-1990s', '1980s–90s sports cards'];
  if (/\b(psa|bgs|sgc)\b/i.test(t)) return ['sell-graded-cards', 'graded cards'];
  return ['sell-sports-cards', 'sports cards'];
}
const sellLine = (title, category) => { const m = sellPageFor(title, category); return m ? `<p class="sell-line">Have one to sell? <a href="/pages/${m[0]}">Free quote on your ${esc(m[1])} →</a></p>` : ''; };

/* sold item pages: keep the page, swap buying for "find me one" + similar items */
const STOP = new Set('the a an of and with for in on to by from cgc cbcs psa bgs sgc pgx raw graded slab white pages off-white cream 1st first appearance app key comic comics card cards book vintage rare new original size rookie rc'.split(' '));
const sigWords = (t) => String(t || '').toLowerCase().replace(/[^a-z0-9#\s-]/g, ' ').split(/\s+/).filter((w) => w.length > 1 && !STOP.has(w) && !/^\d+(\.\d)?$/.test(w));
const catFromPath = (path = []) => {
  const p = path.join('|');
  if (/comic/i.test(p)) return 'Comics';
  if (/non-sport/i.test(p)) return 'Non-Sport Cards';
  if (/sports? (trading )?cards|sports mem/i.test(p)) return 'Sports Cards';
  if (/shoe|sneaker/i.test(p)) return 'Sneakers';
  if (/video game/i.test(p)) return 'Video Games';
  if (/toy/i.test(p)) return 'Toys';
  if (/\bart\b/i.test(p)) return 'Art';
  return '';
};
const soldBox = (title) => `<div class="sold-box">
  <p><b>This one's gone — but we may be able to find you another.</b> Tell us what you're after and we'll reach out when one comes in.</p>
  <div class="ctas"><button class="btn fill" type="button" data-contact data-contact-msg="${esc(title ? `Looking for: ${title}` : 'Looking for: ')}">Find me one</button>
  <a class="btn" href="#related-wrap">Shop similar items</a></div>
  <p class="sold-sell">Have one to sell? <a href="/pages/sell">Get a free appraisal →</a></p></div>`;
let soldMarked = false;
function markSold() {
  if (soldMarked) return; soldMarked = true;
  document.body.classList.add('item-sold');
  const rel = $('related-wrap'), item = document.querySelector('.item-page .item');
  if (rel && item) { item.after(rel); rel.querySelector('h2').textContent = 'similar items available now'; }
}

async function initItem() {
  setupZoom();
  let id = (params.get('id') || '').replace(/\D/g, '');
  if (!id && /contact_posted/.test(location.search)) { // Shopify drops ?id= after the offer form submits
    try { id = (sessionStorage.getItem('nst_offer_item') || '').replace(/\D/g, ''); } catch {}
    if (id) history.replaceState(null, '', `${location.pathname}?id=${id}&contact_posted=true`);
  }
  if (!id) { $('info').innerHTML = '<h1 class="serif">listing not found</h1><p><a href="/pages/shop">Browse all listings →</a></p>'; return; }
  // Old /pages/item?id= links forward to the indexable page (it redirects to the full title slug itself).
  if (!/contact_posted/.test(location.search)) { location.replace('/apps/items/' + id); return; }
  let base = null;
  const show = (it, d) => {
    const title = d?.title || it?.title || 'Listing';
    const price = d?.price ?? it?.price, was = d?.was ?? it?.was;
    const url = d?.url || it?.url || `https://www.ebay.com/itm/${id}`;
    const category = it?.category || catFromPath(d?.path) || '';
    const g = gradeOf(title);
    const off = was && price ? Math.round((1 - price / was) * 100) : 0;
    const images = d?.images?.length ? d.images : it?.image ? [it.image] : [];
    const ended = !!(d?.sold || d?.ended);
    if (ended) markSold(title);
    document.title = `${title} | Nostalgible`;
    const md = document.querySelector('meta[name="description"]');
    if (md && price != null) md.setAttribute('content', `${title} — ${fmt(price)} from Nostalgible. Make an offer or buy on eBay.`);
    $('crumbs').innerHTML = `<a href="/">Home</a> › <a href="/pages/shop">Shop</a>${category ? ` › <a href="${shopUrl(category)}">${esc(category)}</a>` : ''}`;
    // gallery
    const main = $('main-img');
    main.classList.remove('sk');
    main.innerHTML = images.length ? `<img id="main-photo" src="${esc(images[0])}" alt="${esc(title)}"><div class="zoom-lens" id="zoom-lens" hidden></div><span class="zoom-hint" aria-hidden="true">Hover to zoom · click for full size</span>` : '<span class="mono">[Photo]</span>';
    $('thumbs').innerHTML = images.length > 1 ? images.map((src, i) => `<button type="button" class="tb" aria-label="Photo ${i + 1}" aria-pressed="${i === 0}" data-src="${esc(src)}"><img src="${esc(src.replace('s-l1600.', 's-l300.'))}" alt="" loading="lazy"></button>`).join('') : '';
    // info
    const offer = { t: title, id, p: price };
    $('info').innerHTML = `
      <span class="status${ended ? ' is-sold' : ''}">${ended ? 'Sold' : 'Available now'}</span>
      <h1 class="serif">${esc(title)}</h1>
      ${g ? `<span class="grade-chip">${esc(g)}</span>` : ''}
      ${ended ? (price != null ? `<div class="price sold-price">Last listed at ${fmt(price)}</div>` : '') : price != null ? `<div class="price">${fmt(price)}${was ? ` <s>${fmt(was)}</s> <span class="off">${off}% off</span>` : ''}</div>` : ''}
      ${ended ? `<p class="muted">${d?.condition ? esc(d.condition) : ''}</p>` : `<p class="muted">${d?.shipping === 0 ? 'Free shipping' : d?.shipping ? `+ ${fmt(d.shipping)} shipping` : ''}${d?.condition ? ` · ${esc(d.condition)}` : ''}</p>`}
      ${ended ? soldBox(title) : `<div class="ctas">
        <button class="btn fill" type="button" data-offer="${esc(JSON.stringify(offer))}">${d?.offer === false ? 'Buy direct' : 'Make an offer'}</button>
        <a class="btn" href="${esc(url)}" rel="noopener">Buy on eBay</a></div>`}
      ${ended ? '' : `<div class="direct-note"><b>Buy direct, fee-free:</b> send an offer or ask to buy at the listed price — we confirm it's available and email you a payment request by PayPal, or bank wire for larger purchases. Ships insured with tracking once payment clears.</div>`}
      ${d?.conditionDescription ? `<p class="cond">${esc(d.conditionDescription)}</p>` : ''}
      ${d?.short ? `<p class="cond">${esc(d.short)}</p>` : ''}
      ${ended ? '' : sellLine(title, category)}`;
    { const m = sellPageFor(title, category), bb = document.getElementById('buyband-link'); if (m && bb) bb.href = '/pages/' + m[0]; }
    { const sl = document.querySelector('.sold-sell a'); const m = sellPageFor(title, category); if (sl && m) sl.href = '/pages/' + m[0]; }
    // item specifics
    const rows = (d?.aspects || []).map((a) => `<tr><th>${esc(a.n)}</th><td>${esc(a.v)}</td></tr>`).join('');
    $('specs').innerHTML = rows ? `<h2 class="title serif">item details</h2><table>${rows}<tr><th>eBay item #</th><td><a href="${esc(url)}" rel="noopener">${esc(id)}</a></td></tr></table>` : '';
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.tb'); if (!b) return;
    $('main-photo').src = b.dataset.src;
    document.querySelectorAll('.tb').forEach((x) => x.setAttribute('aria-pressed', x === b));
  });
  // 1) instant render from the feed, 2) full details from the worker
  const relate = () => {
    const ref = base || (detail && { title: detail.title, price: detail.price, category: catFromPath(detail.path) });
    if (!ref || !all.length) return;
    const words = sigWords(ref.title);
    const score = (x) => sigWords(x.title).filter((w) => words.includes(w)).length;
    let pool = all.filter((x) => String(x.id) !== id && (!ref.category || x.category === ref.category));
    if (!pool.length) pool = all.filter((x) => String(x.id) !== id);
    const pick = pool.map((x) => [x, score(x)])
      .sort((a, b) => b[1] - a[1] || Math.abs(a[0].price - ref.price) - Math.abs(b[0].price - ref.price))
      .slice(0, 8).map((p) => p[0]);
    if (pick.length) { $('related').innerHTML = pick.map(cardHTML).join(''); $('related-wrap').hidden = false; }
  };
  let detail = null;
  const feedP = loadFeed((data) => { all = data; base = all.find((x) => String(x.id) === id) || base; if (base) show(base, detail); relate(); });
  try {
    const r = await fetch(`${WORKER}/item?id=${id}`);
    if (r.ok) { detail = await r.json(); show(base, detail); relate(); }
  } catch (e) { console.warn('Nostalgible: item detail unavailable', e); }
  await feedP;
  relate();
  if (!base && !detail) {
    markSold('');
    $('main-img').classList.remove('sk'); $('main-img').innerHTML = '<span class="mono">Sold</span>';
    $('info').innerHTML = `<span class="status is-sold">Sold</span><h1 class="serif">this item has sold</h1>${soldBox('')}`;
  }
}

/* ---------- header search ---------- */
function wireHeaderSearch() {
  const hs = $('site-search'); if (!hs) return;
  hs.addEventListener('submit', (e) => {
    if (!$('grid') || $('nostalgible-item')) return; // other pages: normal submit to /pages/shop?q=
    e.preventDefault(); setQuery($('q').value, true);
  });
}

/* ---------- offer / buy-direct request ---------- */
function setupOffer() {
  const dlg = $('offer-dialog'); if (!dlg) return;
  const form = dlg.querySelector('form');
  const amount = $('offer-amount'), amountWrap = $('offer-amount-wrap'), submit = $('offer-submit'), low = $('offer-low');
  const MIN_OFFER = 0.8; // offers more than 20% below the listed price are blocked
  let listed = 0;
  const isOffer = () => form.querySelector('input[name="contact[Request]"]:checked').value === 'Offer';
  const tooLow = () => isOffer() && listed > 0 && Number(amount.value) > 0 && Number(amount.value) < listed * MIN_OFFER;
  const showLow = (on) => { low.hidden = !on; amount.classList.toggle('bad', on); amount.setAttribute('aria-invalid', on ? 'true' : 'false'); };
  // Block a too-low offer before anything else sees the submit (Shopify's spam-check script submits forms itself).
  // 1) browser validation: an invalid field stops the submit before it starts
  const syncValidity = () => amount.setCustomValidity(tooLow() ? 'below minimum' : '');
  amount.addEventListener('input', () => { syncValidity(); if (!low.hidden && !tooLow()) showLow(false); });
  amount.addEventListener('invalid', (e) => { if (tooLow()) { e.preventDefault(); showLow(true); amount.focus(); } });
  // 2) backup: capture-phase listener runs before any other submit handler and cancels it
  window.addEventListener('submit', (e) => {
    if (e.target !== form || !tooLow()) return;
    e.preventDefault(); e.stopImmediatePropagation(); showLow(true); amount.focus(); amount.select();
  }, true);
  const syncType = () => {
    const isOffer = form.querySelector('input[name="contact[Request]"]:checked').value === 'Offer';
    amountWrap.hidden = !isOffer; amount.required = isOffer; if (!isOffer) showLow(false);
    syncValidity();
    submit.textContent = isOffer ? 'Send offer' : 'Request to buy';
    $('offer-title').textContent = isOffer ? 'make an offer' : 'buy direct';
  };
  form.querySelectorAll('input[name="contact[Request]"]').forEach((r) => r.addEventListener('change', syncType));
  const open = (d) => {
    const hasItem = !!d.t;
    $('offer-item-box').hidden = !hasItem;
    $('offer-item-field').hidden = hasItem;
    $('offer-item').value = hasItem ? d.t : '';
    $('offer-ebay-id').value = d.id || '';
    $('offer-listed').value = d.p ? fmt(d.p) : '';
    $('offer-item-label').textContent = d.t || '';
    $('offer-item-price').textContent = d.p ? `Listed on eBay at ${fmt(d.p)}` : '';
    listed = Number(d.p) || 0; showLow(false); amount.setCustomValidity('');
    try { if (d.id) sessionStorage.setItem('nst_offer_item', String(d.id)); } catch {}
    amount.value = ''; amount.placeholder = d.p ? `e.g. ${Math.round(d.p * 0.9)}` : '';
    form.querySelector('input[value="Offer"]').checked = true; syncType();
    stopAuto(); dlg.showModal();
    (hasItem ? amount : $('offer-item')).focus();
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-offer]');
    if (b) { e.preventDefault(); try { open(JSON.parse(b.dataset.offer || '{}')); } catch { open({}); } }
    if (e.target.closest('[data-close]')) dlg.close();
  });
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  syncType();
  if (dlg.querySelector('[data-offer-errors]')) { $('offer-item-field').hidden = false; $('offer-item-box').hidden = true; dlg.showModal(); }
  if (dlg.querySelector('[data-offer-posted]') || /contact_posted=true/.test(location.search)) {
    const t = $('offer-toast'); t.hidden = false; setTimeout(() => { t.hidden = true; }, 9000);
  }
}

function setupContact() {
  const dlg = $('contact-dialog'); if (!dlg) return;
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-contact]');
    if (c) {
      e.preventDefault(); stopAuto();
      if (c.dataset.contactMsg) {
        dlg.querySelector('textarea[name="contact[body]"]').value = c.dataset.contactMsg + '\n\nGrade / condition / budget: ';
        dlg.querySelector('select[name="contact[Subject]"]').value = 'Question about an item';
      }
      dlg.showModal(); dlg.querySelector('input[name="contact[name]"]').focus();
    }
    if (e.target.closest('[data-close-contact]')) dlg.close();
  });
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  if (location.hash === '#contact') dlg.showModal();
}

/* ---------- appraisal requests: sticky quote bar, confirmation page ---------- */
function setupQuote() {
  // After a successful appraisal request, go to the "what happens next" page.
  // Copies each request to the dashboard's Leads list (Shopify still emails it to you as usual).
  // Shopify's spam check can swallow the normal submit event, so the form is saved as the visitor types
  // and sent again from the success page; the worker drops duplicates.
  const ss = { get: (k) => { try { return sessionStorage.getItem(k); } catch { return null; } }, set: (k, v) => { try { sessionStorage.setItem(k, v); } catch {} }, del: (k) => { try { sessionStorage.removeItem(k); } catch {} } };
  const collect = (form) => {
    const f = {};
    new FormData(form).forEach((v, k) => { const m = /^contact\[(.+)\]$/.exec(k); if (m && typeof v === 'string' && v.trim()) f[m[1]] = v.trim(); });
    return f;
  };
  const sendLead = (payload) => {
    let queued = false;
    try { queued = navigator.sendBeacon(`${WORKER}/lead`, new Blob([payload], { type: 'text/plain' })); } catch {}
    if (!queued) { try { fetch(`${WORKER}/lead`, { method: 'POST', body: payload, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }); } catch {} }
  };
  // Any of the site's forms (appraisal, contact, make-an-offer) lands back on the page with ?contact_posted=true
  const posted = /contact_posted=true/.test(location.search);
  if (posted) {
    const draft = ss.get('nst_lead_draft');
    if (draft && ss.get('nst_lead_sent') !== draft) { sendLead(draft); ss.set('nst_lead_sent', draft); }
    ss.del('nst_lead_draft');
    if (document.querySelector('.sell-ok') && ss.get('nst_quote_sent') === '1') { ss.del('nst_quote_sent'); setTimeout(() => location.replace('/pages/quote-received'), 400); return; }
  }
  const saveDraft = (form) => {
    const f = collect(form);
    if (f.email) ss.set('nst_lead_draft', JSON.stringify({ f, url: location.href.split('?')[0] }));
  };
  const onSubmit = (form) => {
    saveDraft(form);
    if (form.classList.contains('sell-form')) ss.set('nst_quote_sent', '1'); else ss.del('nst_quote_sent');
    const draft = ss.get('nst_lead_draft');
    if (draft && ss.get('nst_lead_sent') !== draft) { sendLead(draft); ss.set('nst_lead_sent', draft); }
  };
  const formOf = (el) => el && el.closest && el.closest('form.sell-form, form.offer-form');
  document.addEventListener('input', (e) => { const fm = formOf(e.target); if (fm) saveDraft(fm); }, true);
  document.addEventListener('change', (e) => { const fm = formOf(e.target); if (fm) saveDraft(fm); }, true);
  document.addEventListener('submit', (e) => { const fm = formOf(e.target); if (fm) onSubmit(fm); }, true);
  document.addEventListener('click', (e) => { const b = e.target.closest && e.target.closest('button[type=submit], input[type=submit], button:not([type])'); const fm = formOf(b); if (fm && fm.classList.contains('sell-form') && fm.checkValidity()) onSubmit(fm); }, true);
  // Sticky "Get a free quote" bar: shows after scrolling past the top, hides while the form is on screen.
  const bar = $('quote-bar'), form = $('appraisal');
  if (!bar || !form) return;
  let formVisible = false;
  const update = () => { bar.hidden = formVisible || window.scrollY < 500; };
  if ('IntersectionObserver' in window) new IntersectionObserver((es) => { formVisible = es.some((x) => x.isIntersecting); update(); }, { threshold: 0.05 }).observe(form);
  addEventListener('scroll', update, { passive: true });
  bar.querySelector('a').addEventListener('click', (e) => { e.preventDefault(); form.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  update();
}

/* ---------- appraisal-form photo uploads (stored by the worker; the form submits one gallery link) ---------- */
function setupPhotoUploads() {
  document.querySelectorAll('[data-photos]').forEach((box) => {
    const input = box.querySelector('input[type=file]'), thumbs = box.querySelector('.photo-thumbs'), hidden = box.querySelector('input[name="contact[Photos]"]');
    const form = box.closest('form'), submit = form && form.querySelector('button[type=submit]');
    const batch = Array.from(crypto.getRandomValues(new Uint8Array(16)), (x) => 'abcdefghijklmnopqrstuvwxyz0123456789'[x % 36]).join('');
    let queue = Promise.resolve(), pending = 0, done = 0;
    const MAX = 12;
    const msg = (t) => { let m = box.querySelector('.photo-msg'); if (!m) { m = document.createElement('p'); m.className = 'photo-msg'; box.appendChild(m); } m.textContent = t; };
    const busy = () => { if (submit) { submit.disabled = pending > 0; submit.textContent = pending > 0 ? `Uploading photos… (${pending} left)` : 'Request my free appraisal'; } };
    const shrink = async (file) => {
      try {
        const bmp = await createImageBitmap(file);
        const k = Math.min(1, 1600 / Math.max(bmp.width, bmp.height));
        const c = document.createElement('canvas'); c.width = Math.round(bmp.width * k); c.height = Math.round(bmp.height * k);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        return await new Promise((res) => c.toBlob(res, 'image/jpeg', 0.82));
      } catch { return /^image\/(jpeg|png|webp)$/.test(file.type) && file.size <= 2e6 ? file : null; }
    };
    const add = (files) => {
      for (const file of Array.from(files || [])) {
        if (done + pending >= MAX) { msg(`Up to ${MAX} photos — for more, add a photo link below.`); break; }
        if (!/^image\//.test(file.type) && !/\.(heic|heif|jpe?g|png|webp)$/i.test(file.name)) continue;
        const el = document.createElement('div'); el.className = 'pt'; el.innerHTML = '<span>uploading…</span>';
        try { const im = document.createElement('img'); im.src = URL.createObjectURL(file); im.alt = ''; el.prepend(im); } catch {}
        thumbs.appendChild(el); pending++; busy();
        queue = queue.then(async () => {
          try {
            const blob = await shrink(file);
            if (!blob) throw new Error("couldn't read this photo");
            const r = await fetch(`${WORKER}/upload?b=${batch}`, { method: 'POST', headers: { 'Content-Type': blob.type || 'image/jpeg' }, body: blob });
            const j = await r.json().catch(() => ({}));
            if (!r.ok || !j.ok) throw new Error(j.error || 'upload failed');
            done = j.count; hidden.value = `${j.gallery}  (${j.count} photo${j.count === 1 ? '' : 's'})`;
            el.querySelector('span').textContent = '✓';
          } catch (e) { el.classList.add('err'); el.querySelector('span').textContent = 'failed'; msg(`One photo didn't upload (${e.message}). You can still send the form.`); }
          pending--; busy();
        });
      }
    };
    input.addEventListener('change', () => { add(input.files); input.value = ''; });
    ['dragenter', 'dragover'].forEach((ev) => box.addEventListener(ev, (e) => { e.preventDefault(); box.classList.add('drag'); }));
    ['dragleave', 'drop'].forEach((ev) => box.addEventListener(ev, (e) => { e.preventDefault(); box.classList.remove('drag'); }));
    box.addEventListener('drop', (e) => add(e.dataTransfer && e.dataTransfer.files));
    if (form) form.addEventListener('submit', (e) => { if (pending > 0) { e.preventDefault(); msg('Hang on — photos are still uploading.'); } });
  });
}

/* ---------- customer reviews (recent positive eBay feedback) ---------- */
async function setupReviews() {
  const boxes = document.querySelectorAll('[data-reviews]');
  if (!boxes.length) return;
  let data;
  try { data = await (await fetch(`${WORKER}/reviews.json?n=12`)).json(); } catch { return; }
  const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const when = (d) => { try { return new Date(d + 'T12:00:00Z').toLocaleDateString('en-US', { month: 'short', year: 'numeric' }); } catch { return ''; } };
  boxes.forEach((box) => {
    const n = Number(box.dataset.n) || 6, list = (data.reviews || []).slice(0, n);
    const stats = box.querySelector('[data-rv-stats]');
    if (stats && data.yearLabel) stats.innerHTML = `<b>${esc(data.yearLabel)}</b> positive reviews in the last 12 months · <b>100,000+</b> collectibles sold`;
    const prof = box.querySelector('[data-rv-profile]'); if (prof && data.profile) prof.href = data.profile;
    const grid = box.querySelector('[data-rv-grid]');
    if (!list.length) { if (grid) grid.remove(); return; }
    grid.innerHTML = list.map((r) => `<figure class="rv-card"><div class="rv-stars" aria-hidden="true">★★★★★</div><blockquote>“${esc(r.t)}”</blockquote><figcaption><b>${esc(r.u)}</b> · ${esc(when(r.d))}${r.i ? `<span class="rv-item">${esc(r.i)}</span>` : ''}</figcaption></figure>`).join('');
  });
}

function boot() {
  if ($('yr')) $('yr').textContent = new Date().getFullYear();
  setupOffer();
  setupContact();
  setupQuote();
  setupPhotoUploads();
  setupReviews();
  wireHeaderSearch();
  if ($('nostalgible-item')) initItem();
  // server-rendered item pages (/apps/items/…): same zoom + thumbnail switching as the old item page
  if (document.querySelector('.px-item #main-img')) {
    setupZoom();
    document.addEventListener('click', (e) => {
      const b = e.target.closest('.tb'); if (!b || !$('main-photo')) return;
      $('main-photo').src = b.dataset.src;
      document.querySelectorAll('.tb').forEach((x) => x.setAttribute('aria-pressed', x === b));
    });
  }
  else if ($('grid')) initListings();
}
boot();
